module.exports = __webpack_public_path__ + "img/gpay.be2446db.svg";